import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/retours.svg';
export default {
  name: 'Return',
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    urlPrefix: function urlPrefix() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    }
  })
};